export const SearchIssuerStyles = {
	mainContainer: "flex flex-col justify-center items-center w-full",
	searchContainer: "w-full sm:w-4/4 md:w-3/4 flex justify-start items-center bg-iw-background shadow-iw rounded-lg",
	searchIcon: "m-2 sm:m-3 md:m-4 lg:m-5",
	searchInput: "py-2 sm:py-3 md:py-4 lg:py-6 w-3/4 sm:w-11/12 text-iw-searchTitle focus:outline-none overflow-ellipsis ml-0 mr-2 sm:mr-3 md:mr-4 lg:mr-10",
	clearSearchIcon: "m-2 sm:m-3 md:m-4 lg:m-5 cursor-pointer",
	helperAndErrorTextContainer: "text-left w-full sm:w-4/4 md:w-3/4 mt-3",
  regexError: "text-iw-red text-sm-plus",
  infoMsg: "text-iw-closeIcon text-sm-plus"
};